import gql from 'graphql-tag';

export const QUERY_LANDLORD_LOGIN_SECURITY = gql`
  query QueryLandlordCompany($userUuid: NonEmptyString!) {
    landlordContact(userUuid: $userUuid) {
      enabled
      id
      phone
      email
    }
  }
`;

export const CONFIRM_PASSWORD = gql`
  mutation mutationLandlordAccountLogin($input: LandlordAccountLoginInput) {
    landlordAccountLogin(input: $input) {
      authToken
    }
  }
`;

export const UPDATE_ACCOUNT_PASSWORD = gql`
  mutation CMS_updateAccount($input: UpdateLandlordContactInput!) {
    updateLandlordContact(input: $input) {
      landlordContact {
        id
      }
    }
  }
`;

export const QUERY_GET_API_TOKENS = gql`
  query PMS_GetApiTokens($roleId: ID!) {
    getApiTokens(roleId: $roleId) {
      edges {
        node {
          apiToken
          createdAt
          description
          id
          label
          lastAccessedAt
          status
          updatedAt
        }
      }
      totalCount
    }
  }
`;

export const MUTATION_CREATE_API_TOKEN = gql`
  mutation PMS_CreateApiToken($input: ApiTokenInput) {
    createApiToken(input: $input) {
      apiToken
      createdAt
      description
      id
      label
      lastAccessedAt
      status
      updatedAt
    }
  }
`;

export const QUERY_LANDLORD_WEBHOOK = gql`
  query QueryLandlord($slug: String!) {
    landlord(slug: $slug) {
      id
      name
      webhook {
        callbackUrl
        valid
      }
    }
  }
`;

export const MUTATION_CREATE_LANDLORD_SUBSCRIPTION = gql`
  mutation CreateLandlordSubscription($input: CreateLandlordSubscriptionInput!) {
    createLandlordSubscription(input: $input) {
      name
      callbackUrl
    }
  }
`;

export const MUTATION_UPDATE_LANDLORD_SUBSCRIPTION = gql`
  mutation UpdateLandlordSubscription($input: UpdateLandlordSubscriptionInput!) {
    updateLandlordSubscription(input: $input) {
      name
      callbackUrl
    }
  }
`;
